import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  private http = inject(HttpClient);
  private readonly isLocalhost = window.location.hostname === 'localhost'
  private readonly geoIpApiUrl = this.isLocalhost ? '/sap-geo' : 'https://www.sap.com/geo-ip';

  getSessionGeolocation(): Observable<HttpResponse<string>> {
    return this.http.get(this.geoIpApiUrl, {
      observe: 'response',
      responseType: 'text'
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorMessage = `Failed to fetch geo-ip, error status: ${error.status}: ${error.message || 'Unknown Error'}`;
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
